<ng-container [formGroup]="editService.formGroup">
    <wbo-multi-select-edit-control [(ngModel)]="model.data['groupBy']" [label]="'wbo.report.edit.field.groupBy.label'"
                                   [placeholder]="'wbo.report.edit.field.groupBy.placeholder'"
                                   [formControlName]="'groupBy'">
        <wbo-select-options>
            <wbo-select-option [value]="'location'"
                               *ngIf="showLocationOption"
                               label="wbo.report.option.subGroupBy.location"></wbo-select-option>
            <wbo-select-option *ngIf="showOutletOption"
                               [value]="'outlet'"
                               label="wbo.report.option.subGroupBy.outlet"></wbo-select-option>
            <wbo-select-option *ngIf="showInventoryOption"
                               [value]="'inventory'"
                               label="wbo.report.option.subGroupBy.inventory"></wbo-select-option>
            <wbo-select-option *ngIf="showInventoryGroupOption"
                               [value]="'inventoryGroup'"
                               label="wbo.report.option.subGroupBy.inventoryGroup"></wbo-select-option>
        </wbo-select-options>
    </wbo-multi-select-edit-control>
</ng-container>
